import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./groups.module.css";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";

interface GroupsProps {
  articleInGroups: MediasAndArticleCountResponse[];
}

export const Groups = ({ articleInGroups }: GroupsProps) => {
  const { t } = useTranslation();
  const navigate = useFixaNavigate();

  const handleGroupClick = (groupId: string) => {
    if (!groupId || !articleInGroups?.[0]?.mediaId) return;
    navigate(
      `/mediamaintenance/groups/${groupId}?mediaId=${articleInGroups[0].mediaId}`
    );
  };

  return (
    <>
      {articleInGroups.length > 0 && (
        <FixaText className={styles["groups-container"]} textStyle="Body.S">
          {t("inGroupsString")}
        </FixaText>
      )}
      {articleInGroups.map((article) => (
        <FixaListView
          id="media-placement-groups-list"
          className={styles["media-placement-list"]}
        >
          <FixaListViewItem
            size="small"
            control="navigational"
            onClick={() => handleGroupClick(article.groupId)}
            inset
            controlIcon="chevronRight"
            id={`media-placement-group-${article.groupId}`}
            data-testid={`group-item-${article.groupId}`}
            title={article.groupName}
            addOn={t("piecesCountString", { count: article.nbrArticles })}
          ></FixaListViewItem>
        </FixaListView>
      ))}
    </>
  );
};
